// @ts-ignore // No Type Declaration Avail
import { configure, makeAutoObservable } from "mobx"
// @ts-ignore // No Type Declaration Avail
import { isHydrated, makePersistable, clearPersistedStore } from "mobx-persist-store"
// import { EncryptStorage } from "encrypt-storage"
import { HideInactiveTickets, ModuleName, TAdvancedFilter, TAdvancedFilterAPI } from "./AppStore.types"

// const encryptStorage: any = new EncryptStorage("8AML9axPi0")

configure({
  enforceActions: "always",
  computedRequiresReaction: true,
  reactionRequiresObservable: true,
  observableRequiresReaction: true,
  disableErrorBoundaries: true,
})

class AppStore {
  userDetails: any = {}
  device: 0 | 1 = 1 // Mobile or Desktop
  sideBarCollapse: boolean = false
  counterCardFilter: Record<ModuleName, string> = {
    // Filter State
    [ModuleName.AND]: "All Time",
    [ModuleName.PURCHASE]: "All Time",
    [ModuleName.CLEANS]: "All Time",
    [ModuleName.MAINTENANCE]: "All Time",
  }

  // [{ operator: "and", column: "", value: "" }]
  advancedFilterDef: TAdvancedFilter = [{ column: "", value: "" }]
  advancedFilter: Record<ModuleName, TAdvancedFilter> = {
    // Advanced Filter State / Used for Prefilling
    [ModuleName.AND]: this.advancedFilterDef,
    [ModuleName.PURCHASE]: this.advancedFilterDef,
    [ModuleName.CLEANS]: this.advancedFilterDef,
    [ModuleName.MAINTENANCE]: this.advancedFilterDef,
  }

  advancedFilterCache: Record<ModuleName, TAdvancedFilterAPI> = {
    // Advanced Filter State / Used for Prefilling
    [ModuleName.AND]: {},
    [ModuleName.PURCHASE]: {},
    [ModuleName.CLEANS]: {},
    [ModuleName.MAINTENANCE]: {},
  }

  isHideInactiveTickets: Record<ModuleName, HideInactiveTickets> = {
    [ModuleName.AND]: { isTrue: false, field_key: 'current_status' },
    [ModuleName.PURCHASE]: { isTrue: false, field_key: 'taskStatus' },
    [ModuleName.CLEANS]: { isTrue: false, field_key: 'clean_status' },
    [ModuleName.MAINTENANCE]: { isTrue: false, field_key: 't_status' },
  }

  constructor() {
    makeAutoObservable(this)
    makePersistable(this, {
      name: "AppStore_markStore_RecoveryCache_Int",
      properties: ["sideBarCollapse", "counterCardFilter", "advancedFilter", "advancedFilterCache", "userDetails", "isHideInactiveTickets"],
      // storage: encryptStorage,
      storage: typeof window !== "undefined" ? window.localStorage : undefined,
      version: 2,
    })
  }

  isStoreHydrated = (): boolean => isHydrated(this)
  clearStoredData = async () => {
    await clearPersistedStore(this)
  }

  setUserDetails = (details: any) => (this.userDetails = details)
  setDevice = (device: 0 | 1) => (this.device = device)
  setSideBarCollapse = (state: boolean) => (this.sideBarCollapse = state)
  setCounterCardFilter = (state: Record<string, string>) => (this.counterCardFilter = state)
  setAdvancedFilter = (moduleName: ModuleName, filters: TAdvancedFilter) => {
    this.advancedFilter[moduleName] = filters
  }

  setIsHideInactiveTickets = (moduleName: ModuleName, value: boolean) => {
    this.isHideInactiveTickets[moduleName] = { ...this.isHideInactiveTickets[moduleName], isTrue: value }
  }

  setAdvancedFilterCache = (moduleName: ModuleName, filters: TAdvancedFilterAPI) => {
    this.advancedFilterCache[moduleName] = filters
  }

}

export default new AppStore()
